module.exports = __webpack_public_path__ + "img/devops.8bcb41e7.svg";